import { gql } from "gql";

export const SEND_UNREAD_COMPANY_DOCUMENT_NOTIFICATION = gql(/* GraphQL */ `
  mutation SendUnreadCompanyDocumentNotification(
    $documentId: ID!
    $personIds: [ID!]
  ) {
    sendUnreadCompanyDocumentNotification(
      documentId: $documentId
      personIds: $personIds
    )
  }
`);
